import {takeEvery, put, call, all, fork} from "redux-saga/effects"

import {
  GROUPS_LIST,
  GROUPS_NEW,
  GROUPS_EDIT,
  GROUPS_DELETE
} from "./actionTypes"

import {
  groupsListSuccess,
  groupsListError,
  groupsNewSuccess,
  groupsNewError,
  groupsDeleteSuccess,
  groupsDeleteError
} from "./actions"

import {
  apiGetGroupsList,
  apiPostGroupsNew,
  apiPatchGroupsEdit,
  apiDeleteGroupsDelete,
} from "../../api/calls/groups"

function* groupsList({payload: data}) {
  try {
    const response = yield call(apiGetGroupsList, data)
    yield put(groupsListSuccess(response))
  } catch (error) {
    yield put(groupsListError(error))
  }
}

function* groupsNew({payload: data}) {
  try {
    const response = yield call(apiPostGroupsNew, data)
    yield put(groupsNewSuccess(response))
  } catch (error) {
    yield put(groupsNewError(error))
  }
}

function* groupsEdit({payload: data}) {
  try {
    const response = yield call(apiPatchGroupsEdit, data)
    yield put(groupsNewSuccess(response))
  } catch (error) {
    yield put(groupsNewError(error))
  }
}

function* groupsDelete({payload: data}) {
  try {
    const response = yield call(apiDeleteGroupsDelete, data)
    yield put(groupsDeleteSuccess(response))
  } catch (error) {
    yield put(groupsDeleteError(error))
  }
}

export function* watchGroupsList() {
  yield takeEvery(GROUPS_LIST, groupsList);
}

export function* watchGroupsNew() {
  yield takeEvery(GROUPS_NEW, groupsNew);
}

export function* watchGroupsEdit() {
  yield takeEvery(GROUPS_EDIT, groupsEdit);
}

export function* watchGroupsDelete() {
  yield takeEvery(GROUPS_DELETE, groupsDelete);
}

function* groupsSaga() {
  yield all([
    fork(watchGroupsList),
    fork(watchGroupsNew),
    fork(watchGroupsEdit),
    fork(watchGroupsDelete),
  ]);
}

export default groupsSaga
